module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- Snackbar Material Design Component (MDC) -->\n<!-- https://material.io/develop/web/components/snackbars/ -->\n<div class="mdc-snackbar"\n     aria-live="assertive"\n     aria-atomic="true"\n     aria-hidden="true">\n  <div class="mdc-snackbar__text"></div>\n  <div class="mdc-snackbar__action-wrapper">\n    <button type="button" class="mdc-snackbar__action-button"></button>\n  </div>\n</div>\n';
}
return __p;
};
